import DeviceCard from "./DeviceCard"
import removeIcon from '../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/trash.png'

const TeltonikaCard = ({teltonika, pinObject}) => {

    console.log(teltonika);

    const sensorType = "Teltonika sensor"
    const sensorID = teltonika.type.split(" ")

    console.log(sensorID[1]);
    const unlink = () => {

    }
    
    return (
        <DeviceCard
            header={`${sensorType}`}
            meta={[sensorID[1]]}
            rightContent={
            <>
                <h3 style={{color:"var(--Primary-Color)"}}>{pinObject.pinName}</h3>
                <img src={removeIcon} style={{width:"25px"}} onClick={() => unlink()} />
            </>
            }
        />
        );
}

export default TeltonikaCard;